<!--
  +---------------------------------------------------------------------------------------
  | @Copyright: Frippler Copyright (c)
  | @Title:     启动画面设置
  +---------------------------------------------------------------------------------------
-->

<template>
  <el-dialog
    class="screen-setting"
    width="900px"
    title="启动画面"
    :visible.sync="dialogShow"
    append-to-body
    :modal-append-to-body="false"
    :close-on-click-modal="false">
    <div v-loading="loading" style="margin: 0 150px;">
      <el-radio-group v-model="active_type">
        <el-radio label="system">系统内置</el-radio>
        <el-radio label="image">自定义</el-radio>
      </el-radio-group>
      <div v-if="active_type === 'system'" class="screen-container mt-md">
        <div class="screen-wrapper">
          <div class="screen-inner">
            <el-image :src="screen2" :preview-src-list="[screen2]" class="image" :zIndex="9999" />
            <div v-if="active_screen_id == 2" class="checked"><i class="el-icon-check"></i></div>
            <div class="mask">
              <div v-if="active_screen_id == 2" class="font-md text-white">当前选择</div>
              <el-button v-else type="primary" @click="selectScreen(2)">选择画面</el-button>
            </div>
          </div>
        </div>
        <div class="screen-wrapper">
          <div class="screen-inner">
            <el-image :src="screen1" :preview-src-list="[screen1]" class="image" :zIndex="9999" />
            <div v-if="active_screen_id == 1" class="checked"><i class="el-icon-check"></i></div>
            <div class="mask">
              <div v-if="active_screen_id == 1" class="font-md text-white">当前选择</div>
              <el-button v-else type="primary" @click="selectScreen(1)">选择画面</el-button>
            </div>
          </div>
        </div>
      </div>
      <div v-if="active_type === 'image'" class="mt-md flex mb-lg">
        <Upload action :file-list="bgArr" :show-file-list="false" :before-upload="beforeUpload" :on-success="onScreenChange"
          aimPath="custom/">
          <div v-loading="uploading" class="upload-content">
            <i v-if="!active_screen_id || active_screen_id > 0" class="el-icon-plus upload-icon text-muted" />
            <el-image v-if="active_screen_id == -1 && active_screen_image_url" :src="active_screen_image_url" class="upload-image" fit="cover" />
            <div v-if="active_screen_id == -1 && active_screen_image_url" class="upload-action" role="button">替换</div>
          </div>
        </Upload>
        <div class="tips ml">
          <div v-if="active_screen_id == -1 && active_screen_image_url" role="button" class="preview text-success" @click="preview">预览</div>
          <div class="tip text-muted font-sm">建议图片尺寸780×1688</div>
        </div>
      </div>
    </div>
    <template v-if="active_screen_image_url">
      <el-image v-show="false" ref="previewImageId" :src="active_screen_image_url" :preview-src-list="[ active_screen_image_url ]"/>
    </template>
  </el-dialog>
</template>

<script>

export default {
  name: 'ScreenSet',

  components: {
    Upload: ()=>import('@/components/FUpload')
  },

  props: {
    show: {
      type: Boolean,
      default: false
    },

    slogan: {
      type: String,
      default: ''
    },

    slogan_top: {
      type: String,
      default: ''
    },

    startup_screen_id: {
      type: Number,
      default: 2
    },

    startup_screen_image_url: {
      type: String,
      default: ''
    },

  },

  data() {
    return {
      loading: false,
      active_type: 'system',
      active_screen_id: 2,
      active_screen_image_url: '',
      uploading: false,
      bgArr: [],
      screen1: require('@/assets/slogan-preview1.jpg'),
      screen2: require('@/assets/slogan-preview2.jpg'),
    }
  },

  computed: {
    dialogShow: {
      get() {
        return this.show
      },
      set(val) {
        this.$emit('update:show', val)
      }
    }
  },

  created() {
    this.active_type = this.startup_screen_id > 0 ? 'system' : 'image'
    this.active_screen_id = this.startup_screen_id || 2
    this.active_screen_image_url = this.startup_screen_image_url || ''
  },

  methods: {
    selectScreen(id) {
      const temp = {
        startup_screen_id: id
      }
      this.$store.dispatch('setGodCustomizationAction', temp).then((res) => {
        this.loading = false
        if (!res.errno) {
          this.active_screen_id = id
          this.$message.success('启动画面设置成功')
        } else {
          this.$message.error(res.message)
        }
      }).catch((err) => {
        console.error(err)
      })
    },

    preview() {
      this.$nextTick(() => {
        this.$refs['previewImageId'].clickHandler();
      })
    },

    beforeUpload (file) {
      const formatArr = ["image/jpeg", "image/png", "image/webp", "image/gif"]
      if (formatArr.indexOf(file.type) === -1) {
        this.$message.error('上传图片格式支持jpg、png、webp、gif！')
        return false
      }
      if (file.size > 2048 * 1024) {
        this.$message.error('上传图片大小不能超过 2M')
        return false
      }
      this.uploading = true
      return true
    },

    onScreenChange (res) {
      this.uploading = false
      if (!res.errno) {
        const temp = {
          startup_screen_image_url: res.data.url
        }
        this.$store.dispatch('setGodCustomizationAction', temp).then((resp) => {
          this.loading = false
          if (!res.errno) {
            this.active_screen_image_url = res.data.url
            this.active_screen_id = -1
            this.$message.success('启动画面设置成功')
          } else {
            this.$message.error(resp.message)
          }
        }).catch((err) => {
          console.error(err)
        })
      } else {
        this.$message.error(res.message)
      }
    },

  }
}
</script>

<style lang="scss" scoped>
.screen-setting {
  .screen-container {
    display: flex;
    flex-wrap: wrap;
    justify-content: flex-start;
    .screen-wrapper {
      margin: 0 30px 32px 0;
      .screen-inner {
        position: relative;
        border-radius: 5px;
        box-shadow: 0px 8px 8px 0 rgba(0, 0, 0, .2);
        overflow: hidden;
        .image {
          width: 250px;
          height: 535px;
        }
        .checked {
          position: absolute;
          top: 0;
          right: 0;
          width: 50px;
          height: 50px;
          background: linear-gradient(225deg, #07c160 50%, transparent 50%);
          color: #fff;
          font-size: 28px;
          text-align: right;
        }
        .mask {
          position: absolute;
          left: 0;
          right: 0;
          bottom: 0;
          height: 80px;
          background: linear-gradient(0deg, rgba(0, 0, 0, .8) 0%, rgba(0, 0, 0, .1) 100%);
          display: flex;
          align-items: center;
          justify-content: center;
          opacity: 0;
          transition: all .2s;
        }
        &:hover .mask {
          opacity: 1;
        }
      }
    }
  }
  /deep/ .el-upload {
    position: relative;
    width: 250px;
    height: 535px;
    line-height: 250px;
    border-radius: 6px;
    background: #fff;
    border: 1px dashed #c0ccda;
    &:hover {
      border-color: #07c160;
    }
    .upload-content {
      width: 248px;
      height: 533px;
      .upload-icon {
        font-size: 32px;
        line-height: 533px;
      }
      .upload-image {
        width: 248px;
        height: 533px;
        border-radius: 6px;
      }
      .upload-action {
        position: absolute;
        width: 100%;
        height: 100%;
        left: 0;
        top: 0;
        cursor: pointer;
        text-align: center;
        color: #fff;
        opacity: 0;
        font-size: 40px;
        line-height: 533px;
        background-color: rgba(0, 0, 0, 0.5);
        &:hover {
          opacity: 1;
        }
      }
      .el-loading-spinner {
        top: 25%
      }
    }

  }
  .tips {
    width: 200px;
    position: relative;
    .tip {
      position: absolute;
      bottom: 10px;
      left: 0;
    }
  }
}
</style>
